module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/qfCzKo/tc-custom/9781625847041.jpg?1702530062664",
      "alt": "This image is the cover for the book The New England Mariner Tradition: Old Salts, Superstitions, Shanties and Shipwrecks"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The New England Mariner Tradition: Old Salts, Superstitions, Shanties and Shipwrecks\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("For over three centuries, New Englanders have set sail in search of fortune and adventure--yet death lurked on every voyage in the form of storms, privateers, disease and human error. In hope of being spared by the sea, superstitious mariners practiced cautionary rituals. During the winter of 1779, the crew aboard the \"Family Trader\" offered up gin to appease the squalling storms of Neptune. In the 1800s, after nearly fifty shipwrecks on Georges Bank between Cape Cod, Massachusetts, and Nova Scotia, a wizard paced the coast of Marblehead, shouting orders out to sea to guide passing ships to safety. As early as 1705, courageous settlers erected watch houses and lighted beacons at Beavertail Point outside Jamestown, Rhode Island, to aid mariners caught in the swells of Narragansett Bay. Join Robert A. Geake as he explores the forgotten traditions among New England mariners and their lives on land and sea.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robert A. Geake\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Robert Geake is the bookseller and events coordinator for Brown University Bookstore. He is a member of the Rhode Island Historical Society. He wrote A History of the Narragansett Tribe of Rhode Island, Historic Taverns of Rhode Island, and A History of the Providence River.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0